import React from 'react';
import { BusinessInsightsProvider } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/context/BusinessInsightsProvider';
import { BusinessAdminInsightsContent } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/BusinessAdminInsightsContent/BusinessAdminInsightsContent';

export function BusinessAdminInsights(): JSX.Element {
  return (
    <BusinessInsightsProvider>
      <BusinessAdminInsightsContent />
    </BusinessInsightsProvider>
  );
}
